<template>
	<!-- Item của combo không có column -->
	<li
		class="combobox-item single"
		:class="{ parent: item.is_parent, 'ms-combobox-item-last': isLastItem }"
		:style="'text-align: ' + align"
		v-if="comboType === 1"
		v-on="listeners"
	>
		<div
			class="combobox-item-con"
			:class="
				isIconSelect || checkbox ? 'flex jus-between align-item-center' : ''
			"
		>
			<div v-if="checkbox" class="ml-3">
				<ms-checkbox
					:value="item.__multiSelected"
					@click="checkItem"
					class="center"
					checkOnly
				/>
			</div>
			<div class="combobox-item--text" :title="getItemDisplay(item)">
				{{ getItemDisplay(item) }}
			</div>
			<span
				class="trash-icon"
				v-if="hasRemoveItemButton"
				@click="onRemoveItemClick()"
			>
				<span class="mi mi-16 mi-garbage"></span>
			</span>
			<div
				class="mr-5"
				v-if="item.__multiSelected && isIconSelect"
				:class="['mi-new-v2', 'mi-16', 'mi-icon-v2-tick-select']"
			></div>
		</div>
	</li>
	<li
		class="combobox-item single"
		:class="{ parent: item.isParent, 'ms-combobox-item-last': isLastItem }"
		:style="'text-align: ' + align"
		v-else-if="comboType === 3 && columnx.length == 0"
		v-on="listeners"
	>
		<div
			class="combobox-item-con"
			:class="
				isIconSelect || checkbox ? 'flex jus-between align-item-center' : ''
			"
		>
			<div v-if="checkbox" class="ml-3">
				<ms-checkbox
					:value="item.__multiSelected"
					@click="checkItem"
					class="center"
					checkOnly
				/>
			</div>
			<div
				class="combobox-item--text"
				:class="`level-${item.level}`"
				:title="getItemDisplay(item)"
			>
				{{ getItemDisplay(item) }}
			</div>
			<span
				class="trash-icon"
				v-if="hasRemoveItemButton"
				@click="onRemoveItemClick()"
			>
				<span class="mi mi-16 mi-garbage"></span>
			</span>
			<div
				class="mr-5"
				v-if="item.__multiSelected && isIconSelect"
				:class="['mi-new-v2', 'mi-16', 'mi-icon-v2-tick-select']"
			></div>
		</div>
	</li>
	<!-- Item của combo có column -->
	<tr
		class="combobox-item"
		:class="{ parent: item.isParent, 'ms-combobox-item-last': isLastItem }"
		v-else
		v-on="listeners"
	>
		<td v-if="serial" class="ms-td-serial text-center" style="min-width: 50px">
			{{ rowIndex + 1 }}
		</td>
		<td v-if="checkbox" class="ml-3">
			<ms-checkbox
				:value="item.__multiSelected"
				@click="checkItem"
				class="center"
				checkOnly
			/>
		</td>
		<td
			class="combobox-item-td"
			v-for="(column, tdIndex) in columnx"
			:key="tdIndex"
			:class="comboType === 3 && tdIndex === 0 ? `level-${item.level}` : null"
			:style="getTdStyle(column)"
		>
			<div class="combobox-item-td--contents">
				<div
					:title="getItemDisplay(item, column)"
					class="combobox-item-td--text"
				>
					{{ getItemDisplay(item, column, tdIndex) }}
				</div>
			</div>
		</td>
		<td class="selected-container">
			<div
				v-if="item.__multiSelected"
				:class="['mi-new-v2', 'mi-16', 'mi-icon-v2-tick-select']"
			></div>
		</td>
	</tr>
</template>

<script>
export default {
	name: 'MsComboBoxItem',
	props: {
		/**
		 * Loại combo
		 */
		comboType: {
			type: Number,
			default: 1,
		},

		/**
		 * Item sử dụng để binding
		 */
		item: {},

		/**
		 * Cấu hình cột của menu
		 */
		columnx: {
			type: Array,
			default: [],
		},
		/**
		 * Trường làm value
		 * CreatedBy PDKIEN 10/12/2019
		 */
		valueField: {
			type: String,
			default: null,
		},
		/**
		 * Trường là display
		 * CreatedBy PDKIEN 10/12/2019
		 */
		displayField: {
			type: String,
			default: null,
		},

		/**
		 * Trạng thái có btn `Xóa` trong item
		 */
		hasRemoveItemButton: {
			type: Boolean,
			default: false,
		},
		/**
		 * Kiểu định dạng dữ liệu trên combobox
		 * Tương ứng với FormatType
		 * CreatedBy PDKIEN 07/12/2019
		 */
		formatType: {
			type: [Number, String],
			default: null,
		},
		align: {
			type: String,
			default: 'left',
		},
		rowIndex: {
			type: Number,
			default: null,
		},
		serial: {
			default: false,
			type: Boolean,
		},
		isIconSelect: {
			default: false,
			type: Boolean,
		},
		checkbox: {
			default: false,
			type: Boolean,
		},
		/**
		 * Đánh dấu item cuối cùng của danh sách (theo data, không theo DOM render của virtual scroll)
		 * Dùng để ẩn border-bottom item cuối khi dropdown có scroll, tránh đè lên border khung bao ngoài combo-dropdown-panel
		 */
		isLastItem: {
			default: false,
			type: Boolean,
		},
	},
	computed: {
		/**
		 * Binding sự kiện của menu item
		 */
		listeners() {
			const me = this;
			return {
				...me.$listeners,
			};
		},
	},
	methods: {
		/**
		 * Hàm lấy style cho td trong table
		 * dữ liệu động theo config của dev
		 */
		getTdStyle(column) {
			return {
				width: column.isResize ? null : `${column.width}px`,
				textAlign: column.columnAlign,
			};
		},

		/**
		 * Lấy text hiển thị trên item
		 * Nếu có column lấy theo column.field, nếu không có column lấy theo displayField, nếu không có displayField lấy theo valueField
		 * CreatedBy PDKIEN 10/12/2019
		 */
		getItemDisplay(item, column, tdIndex) {
			let field = column
				? column.dataField
				: this.displayField || this.valueField;
			if (field) {
				return item[field];
			} else {
				return item;
			}
		},

		/**
		 * Xử lý sự kiện khi click icon xóa item
		 */
		onRemoveItemClick() {
			this.$emit('removeItem');
		},
		checkItem(event) {
			const me = this;
			me.$emit('checkItem', me.item);
		},
	},
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msComboboxItem.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msComboboxItem.scss';
}
.ms-td-serial {
	min-width: 50px;
	width: 50px;
	max-width: 50px;
	height: 100%; // lấp đầy chiều cao row 36px, tránh co theo nội dung gây border lệch với cột khác
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	border-bottom: 1px solid #ced1d6; // = $ms-border-color, hardcode vì ngoài scope @media import biến
}
</style>
